import React, { useState } from 'react';
import { IdUploadScreen } from './screens/IdUploadScreen';
import { RegistrationCertScreen } from './screens/RegistrationCertScreen';
import { AddressProofScreen } from './screens/AddressProofScreen';
import { DocumentsReviewScreen } from './screens/DocumentsReviewScreen';
type Screen = 'id' | 'reg' | 'address' | 'review';
interface DocumentsJourneyProps {
  onComplete: () => void;
}
export function DocumentsJourney({
  onComplete
}: DocumentsJourneyProps) {
  const [currentScreen, setCurrentScreen] = useState<Screen>('id');
  // State for all steps
  const [idFile, setIdFile] = useState<File | null>(null);
  const [regCertFile, setRegCertFile] = useState<File | null>(null);
  const [addressProofFile, setAddressProofFile] = useState<File | null>(null);
  const renderScreen = () => {
    switch (currentScreen) {
      case 'id':
        return <IdUploadScreen initialFile={idFile} onNext={file => {
          setIdFile(file);
          setCurrentScreen('reg');
        }} data-id="element-14" />;
      case 'reg':
        return <RegistrationCertScreen initialFile={regCertFile} onBack={() => setCurrentScreen('id')} onNext={file => {
          setRegCertFile(file);
          setCurrentScreen('address');
        }} data-id="element-15" />;
      case 'address':
        return <AddressProofScreen initialFile={addressProofFile} onBack={() => setCurrentScreen('reg')} onNext={file => {
          setAddressProofFile(file);
          setCurrentScreen('review');
        }} data-id="element-16" />;
      case 'review':
        return <DocumentsReviewScreen data={{
          idFile,
          regCertFile,
          addressProofFile
        }} onBack={() => setCurrentScreen('address')} onNext={onComplete} data-id="element-17" />;
      default:
        return null;
    }
  };
  return <div className="h-full w-full max-w-4xl mx-auto p-6" data-id="element-18">{renderScreen()}</div>;
}